<template>
    <div class="paypal-plugin-preview noscroll flex layout-column">
        <div class="layout-column scroll" style="    padding: 10px 15px;">
	        <div class="payment-form-container">
		        <div class="payment-option">
			        <label class="option-header">
				        <input class="input-radio" type="radio" value="cc" name="payment-option" v-model="selectedOption">
				        <span>Credit Card</span>
				        <img class="small-cards" :src="require('@/assets/img/small-cards.png')" />
			        </label>
			        <div class="credit-card-content" v-if="selectedOption==='cc'">
				        <img :src="require('@/assets/img/card-fields.png')" />
			        </div>
		        </div>
		        <div class="payment-option">
			        <label class="option-header paypal" :class="{'open':selectedOption==='paypal'}">
				        <input class="input-radio" type="radio" value="paypal" name="payment-option" v-model="selectedOption" >
				        <span><img :src="require('@/assets/img/paypal.webp')"></span>
			        </label>
			        <div class="paypal-content" v-if="selectedOption==='paypal'">
				        <img :src="require('@/assets/img/offsite-img.png')" />
				        <p id="paypal_message_p">After clicking
					        <span id="span_btn_text" style="font-weight: bold;">"Complete Order"</span>,
					        you will be redirected to PayPal to complete your purchase securely.</p>
			        </div>
		        </div>
	        </div>
	        
	        <v-button class="translate-btn" label="Translate" border @click="translatePopup=true"></v-button>
	        <popup title="PayPal Plugin translator" @close="translatePopup=false" v-show="translatePopup">

		        <template v-slot:content>
			        <div class="" style="padding-top: 10px">
				        <span style="margin-bottom: 10px;display: block;">
					        Below you can change the translation for all your PayPal Plugin app fields</span>
			        <div class="header layout-row">
				        <span class="flex">Label</span>
				        <span class="flex">Translation</span>
			        </div>
			        <div class="layout-row translator-row" v-for="(field, index) in fields" :key="index">
				        <input-field class="flex" readonly v-model="field.id"></input-field>
				        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.3159 10.6608L1.49419 10.6608V8.99415H15.3159L10.0717 3.74999L11.25 2.57166L18.5059 9.82749L11.25 17.0833L10.0717 15.905L15.3159 10.6608Z" fill="#C5C7D2"/>
				        </svg>

				        <input-field @input="copied=false" class="flex" v-model="field.value"></input-field>
			        </div>

				        <p style="margin-bottom: 5px;">Copy the code below to your Order Form's <b>Settings > Head Tracking</b></p>

				        <div class="script">
                <textarea class="code_box_textarea" readonly>
                    {{generatedCode}}
                </textarea>
				        <a @click="copyToClipboard('.code_box_textarea')" class="icon">
					        <inline-svg :src="require('@/assets/img/copy_link_1.svg')"/>
				        </a>
			        </div>

			        <span v-if="copied" style="display: block;color: green;text-align: center;margin-top: 8px;">
				        Your translation code was copied into your clipboard!
			        </span>
			        </div>
		        </template>
		        <template v-slot:actions>
			        <v-button label="Cancel" border @click="translatePopup=false"></v-button>
		        </template>
	        </popup>
        </div>

	    <!-- Quick links -->
	    <div class="layout-column quick-links-container">
		    <div>
			    <h1 class="title">Quick links</h1>
		    </div>
		    <div>
			    <ul>
				    <li>
					    <external-link href="https://docs.funnelish.com/apps/paypal-plugin"
					                   target="_blank" label="How to use the PayPal Plugin app?"> </external-link>
				    </li>
				    <li>
					    <external-link href="https://docs.funnelish.com/apps/paypal-plugin/testing-purchases"
					                   target="_blank" label="Making PayPal test purchases"> </external-link>
				    </li>
			    </ul>
		    </div>
	    </div>

    </div>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import InputField from "@/components/base/input-field";
import ExternalLink from "@/components/base/external-link";

export default {
    name: "paypal_plugin",
	components: {ExternalLink, InputField, Popup, VButton},
	mixins: [API],
	props: ["newUserApp"],
    data() {
        return {
	        fields: [
	          {id:"Credit card", value:"Credit card"},
		        {id:"Card number", value:"Card number"},
		        {id:"MM / YY", value:"MM / YY"},
		        {id:"CVC", value:"CVC"},
		        {id:"Total", value:"Total"},
		        {id:"After clicking {SUBMIT_BUTTON}, you will be redirected to PayPal to complete your purchase securely.",
					    value:"After clicking {SUBMIT_BUTTON}, you will be redirected to PayPal to complete your purchase securely."}
			    ],

	        translatePopup: false,
        	selectedOption: "paypal",
	        copied: false,
        }
    },
    computed: {
    	generatedCode() {
    		let gen = "";

		    this.fields.forEach(x => {
		    	gen += `"${x.id}" : "${x.value}",`
		    })
    		return `<scr`+`ipt>
	PP_TRANSLATE = { ${gen} };
</scr`+`ipt>`
	    }
    },
    methods: {
	    copyToClipboard (queryElem) {
	    	this.copied = false;
		    let elemToCopy = document.querySelector(queryElem);
		    elemToCopy.setAttribute('type', 'text');
		    elemToCopy.select();

		    try {
			    var successful = document.execCommand('copy');
		    } catch (err) {
			    console.log('Oops, unable to copy');
		    }

		    elemToCopy.setAttribute('type', 'hidden')
		    window.getSelection().removeAllRanges();

		    this.copied = true;
	    },
    },
    mounted() {

    }
}
</script>

<style lang="scss" >
    .paypal-plugin-preview {
        padding: 0;
	    .header {
		    span {
			    text-align: center;
			    font-weight: 500;
			    color: #98aacd;
			    margin-bottom: 5px;
		    }
	    }
	    .generated-code {
		    height: 100px;

		    textarea {
			    color: grey;
			    font-size: 12px;
			    line-height: 18px;
			    font-family: monospace;
			    background: whitesmoke;
		    }
	    }
	    .translator-row {
		    margin-bottom: 10px;
		    > svg {
			    margin: auto 15px;
		    }
	    }
	    .translate-btn {
		    margin: 20px auto;
	    }
	    /// TODO: move payment form into independent component
        .payment-form-container {
	        width: 100%;
	        margin-top: 30px;
	        box-shadow: 0 0 0 1px #d9d9d9;
	        border-radius: 4px;
	        background: #fafafa;
	        color: #737373;

	        .payment-option {
		        .option-header {
			        position: relative;
			        cursor: pointer;
			        display: flex;
			        background-color: white;
			        color: #737373;
			        padding: 10px 4px;

			        span {
				        margin: auto 0 auto 5px;
			        }
			        .small-cards {
				        height: 20px;
				        position: absolute;
				        right: 5px;
			        }
			        &.paypal {
				        border-top: 1px solid #d9d9d9;
			        }
			        img {
				        height: 24px;
				        display: block;
			        }
			        input {
				        width: 18px;
				        height: 18px;
				        box-shadow: 0 0 0 0 #f4743c inset;
				        transition: all .2s ease-in-out;
				        position: relative;
				        cursor: pointer;
				        vertical-align: -4px;
				        outline: 0;
				        border: 1px solid #d9d9d9;
				        border-radius: 50%;
				        &:checked {
					        border: 0;
					        box-shadow: 0 0 0 10px #f4743c inset;
				        }
			        }
		        }
		        &:first-child {
			        .option-header {
				        border-radius: 6px 6px 0 0;
			        }
		        }
		        &:last-child {
			        .option-header {
				        border-radius: 0 0 6px 6px;
			        }
			        .option-header.open {
				        border-radius: 0;
			        }
		        }
		        .paypal-content {
			        text-align: center;
			        //padding: 4px;
			        display: table;
			        box-sizing: border-box;
			        width: 100%;
			        padding: 8px 10px 8px 10px;
			        zoom: 1;
			        min-height: 50px;
			        position: relative;
			        border-top: 1px solid #d9d9d9;
			        background-color: #fafafa;
			        p {
				        margin-bottom: 15px;
			        }
		        }
		        .credit-card-content {
			        min-height: 130px;
			        padding: 5px;
			        border-top: 1px solid #d9d9d9;
			        img {
				        pointer-events: none;
				        width: 100%;
			        }
		        }
	        }
        }
    }
</style>
